import ApiService from "@/core/services/api.service";
import Vue from "vue";

export const GET_LOGISTICS_REQUESTS = "GET_LOGISTICS_REQUESTS";
export const WORK_COORDINATION = "WORK_COORDINATION";
export const DELETE_LOGISTICS_REQUEST = "DELETE_LOGISTICS_REQUEST";
export const GET_LOGISTICS_REQUEST_DETAIL = "GET_LOGISTICS_REQUEST_DETAIL";
export const SAVE_PROCESSING_RESULT = "SAVE_PROCESSING_RESULT";
export const GET_DEPARTMENT_QUOTAS = "GET_DEPARTMENT_QUOTAS";
export const UPDATE_DEPARTMENT_QUOTA = "UPDATE_DEPARTMENT_QUOTA";
export const GET_PRODUCTS = "GET_PRODUCTS";
export const CREATE_PRODUCT = "CREATE_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const IMPORT_STOCK = "IMPORT_STOCK";
export const EXPORT_STOCK = "EXPORT_STOCK";
export const GET_LOGISTIC_BRANCHES = "GET_LOGISTIC_BRANCHES";
export const GET_PRICE_HISTORY = "GET_PRICE_HISTORY";
export const GET_STOCK_HISTORY = "GET_STOCK_HISTORY";
export const EXPORT_STOCK_HISTORY = "EXPORT_STOCK_HISTORY";
export const GET_PRODUCT_BARCODES = "GET_PRODUCT_BARCODES";
export const GET_DEPARTMENT_IN_CHARGE = "GET_DEPARTMENT_IN_CHARGE";
export const GET_LIST_USER_GIFT = "GET_LIST_USER_GIFT"
export const CHANGE_STATUS_SEND_GIFT = "CHANGE_STATUS_SEND_GIFT";
export const IMPORT_USER_GIFT = "IMPORT_USER_GIFT";
export const EXPORT_USER_GIFT = "EXPORT_USER_GIFT";
export const EXPORT_LOGISTICS_TICKETS = "EXPORT_LOGISTICS_TICKETS";
export const GET_ACCOUNTING_INVOICES = "GET_ACCOUNTING_INVOICES";
export const GET_ACCOUNTING_INVOICE = "GET_ACCOUNTING_INVOICE";
export const CREATE_ACCOUNTING_INVOICE = "CREATE_ACCOUNTING_INVOICE";
export const UPDATE_ACCOUNTING_INVOICE = "UPDATE_ACCOUNTING_INVOICE";
export const DELETE_ACCOUNTING_INVOICE = "DELETE_ACCOUNTING_INVOICE";
export const EXPORT_ACCOUNTING_INVOICES = "EXPORT_ACCOUNTING_INVOICES";

const ACCOUNTING_INVOICE_RESOURCE = "logistic-accounting-invoices";
export const CHANGE_LOGISTICS_STATUS_MULTIPLE = "CHANGE_LOGISTICS_STATUS_MULTIPLE";

const LOGISTIC_STATUS_LABELS = {
  0: "Chưa tiếp nhận",
  1: "Đang xử lý",
  2: "Đã cung cấp đủ hàng",
  3: "Đã nhận hàng",
  4: "Hoàn thành",
  5: "Hủy",
};

const LOGISTIC_STATUS_TEXT_TO_CODE = Object.entries(LOGISTIC_STATUS_LABELS).reduce(
  (acc, [code, label]) => {
    acc[label] = Number(code);
    return acc;
  },
  {}
);

const TYPE_LABELS = {
  0: "Trụ sở",
  1: "Cơ sở",
  2: "Tất cả",
};

const TYPE_DETAIL_LABELS = {
  1: "Nhu yếu phẩm",
  2: "Văn phòng phẩm",
  3: "Giáo trình",
  4: "Ấn phẩm",
  5: "Chương trình khuyến mại",
};

const STOCK_LOG_TYPE_LABELS = {
  1: "Nhập kho",
  2: "Xuất kho",
};

function normalizeText(value = "") {
  return String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .trim();
}

function getStatusCode(status) {
  if (status === null || status === undefined || status === "") return null;
  if (typeof status === "number") return status;
  return LOGISTIC_STATUS_TEXT_TO_CODE[status] ?? null;
}

function getStatusLabel(status) {
  if (typeof status === "number") {
    return LOGISTIC_STATUS_LABELS[status] || "";
  }
  return status || "";
}

function mapTypeLabel(type) {
  const code = Number(type);
  if (!Number.isNaN(code) && TYPE_LABELS[code] !== undefined) {
    return TYPE_LABELS[code];
  }
  return type || "";
}

function normalizeProductType(type) {
  const code = Number(type);
  return Number.isNaN(code) ? type : code;
}

function mapTypeDetailLabel(typeDetail) {
  const code = Number(typeDetail);
  if (!Number.isNaN(code) && TYPE_DETAIL_LABELS[code] !== undefined) {
    return TYPE_DETAIL_LABELS[code];
  }
  return typeDetail || "";
}

function normalizeProductTypeDetail(typeDetail) {
  const code = Number(typeDetail);
  return Number.isNaN(code) ? typeDetail : code;
}

function buildPaginationFromArray(items = [], page = 1, perPage = 20) {
  const total = items.length;
  const currentPage = Number(page) || 1;
  const limit = Number(perPage) || 20;
  const lastPage = Math.max(1, Math.ceil(total / limit));
  const startIndex = (currentPage - 1) * limit;
  const endIndex = startIndex + limit;

  return {
    data: items.slice(startIndex, endIndex),
    pagination: {
      total,
      count: Math.min(limit, Math.max(total - startIndex, 0)),
      per_page: limit,
      current_page: currentPage,
      last_page: lastPage,
    },
  };
}

function mapRequestItem(item = {}) {
  return {
    id: item.id,
    code: "#" + (item.id || ""),
    name: item.name || "",
    type: mapTypeLabel(item.type !== undefined ? item.type : item.type_code),
    requester_name: item?.user_name ? item.user_name + " - " + (Number(item.user_id) + 100000) : "",
    user_name: item.user_name || "",
    person_in_charge: item?.person_in_charge_name ? item.person_in_charge_name + " - " + (Number(item.person_in_charge_id) + 100000) : "",
    person_in_charge_id: item.person_in_charge_id,
    request_time: item.created_at || "",
    department_name: item.department_name || "",
    facility_name: item.branch_name || "",
    branch_name: item.branch_name || "",
    status: getStatusLabel(item.logistic_ticket_status),
    logistic_ticket_status: item.logistic_ticket_status,
    type_detail: item.type_detail || "",
  };
}

function mapRequestDetail(item = {}) {
  return {
    id: item.id,
    name: item.name || "",
    requester_name: item.user_name || "",
    phone: item.phone || "",
    department_name: item.department_name || "",
    facility_name: item.branch_name || "",
    request_time: item.created_at || "",
    month: item.name ? String(item.name).split("|")[0].trim() : "",
    status: getStatusLabel(item.logistic_ticket_status),
    logistic_ticket_status: item.logistic_ticket_status,
    products: (item.products || []).map((product) => ({
      id: product.id,
      product_name: product.name || "",
      quantity: product.quantity || 0,
      unit_price: product.price || 0,
    })),
    logs: item.logs || [],
    type: item.type
  };
}

function mapHistoryItem(item = {}) {
  const userName = item.user_handle_name || "";
  const initials = userName
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");

  return {
    id: item.id,
    date: item.created_at || "",
    user_name: userName,
    user_initial: initials,
    status: item.status_text || getStatusLabel(item.status),
    description: item.note || "",
  };
}

function mapProductItem(item = {}) {
  const normalizedType = normalizeProductType(item.type);
  const normalizedTypeDetail = normalizeProductTypeDetail(item.type_detail);
  return {
    id: item.id,
    name: item.name || "",
    price: Number(item.price) || 0,
    quantity: Number(item.quantity) || 0,
    type: normalizedType,
    type_detail: normalizedTypeDetail,
    description: item.description || "",
    type_label: mapTypeLabel(normalizedType),
    type_detail_label: mapTypeDetailLabel(normalizedTypeDetail),
    logistic_product_status: item.logistic_product_status,
    logistic_product_status_text: item.logistic_product_status_text || "",
    is_hidden: Number(item.logistic_product_status) === 1,
    barcode: item.barcode ?? "",
    reorder_level: Number(item.reorder_level) || 0,
  };
}

function mapAccountingInvoiceProduct(item = {}) {
  return {
    id: item.id,
    product_id: item.product_id ?? null,
    name: item.name || item.product_name || "",
    product_name: item.product_name || item.name || "",
    quantity: Number(item.quantity) || 0,
    unit_price: Number(item.unit_price) || 0,
    total_amount: Number(item.total_amount) || 0,
  };
}

function mapAccountingInvoice(item = {}) {
  return {
    ...item,
    id: item.id,
    invoice_code: item.invoice_code || "",
    pnk_code: item.pnk_code ?? null,
    products: (item.products || []).map(mapAccountingInvoiceProduct),
    total_amount: Number(item.total_amount) || 0,
    purchase_date: item.purchase_date || "",
    note: item.note ?? "",
    payment_status: Number(item.payment_status) || 0,
    payment_status_text: item.payment_status_text || "",
    payment_code: item.payment_code || "",
    import_status: Number(item.import_status) || 0,
    import_status_text: item.import_status_text || "",
    created_at: item.created_at || "",
  };
}

function buildAccountingInvoicePayload(credentials = {}, includePnkCode = false) {
  const payload = {
    purchase_date: credentials.purchase_date,
    note: credentials.note || null,
    payment_status: Number(credentials.payment_status) || 0,
    products: (credentials.products || []).map((item) => {
      const product = {
        quantity: Number(item.quantity),
        unit_price: Number(item.unit_price),
      };

      if (item.product_id !== null && item.product_id !== undefined && item.product_id !== "") {
        product.product_id = Number(item.product_id);
      } else {
        product.name = String(item.name || "").trim();
      }

      return product;
    }),
  };

  if (includePnkCode) {
    payload.pnk_code = String(credentials.pnk_code || "").trim() || null;
    payload.payment_code = String(credentials.payment_code || "").trim() || null;
  }

  return payload;
}

function mapQuotaItem(item = {}) {
  const quotaValue = Number(item.total_budgets);

  return {
    id: item.id,
    name: item.name || "",
    quota: Number.isNaN(quotaValue) ? null : quotaValue,
    total_budgets: item.total_budgets,
  };
}

const state = {};

const getters = {};

const actions = {
  [GET_ACCOUNTING_INVOICES](context, credentials = {}) {
    const params = { page: credentials.page || 1 };
    [
      "pnk_code",
      "invoice_code",
      "product_id",
      "product_name",
      "purchase_date",
      "created_date",
      "payment_status",
      "import_status",
      "from_date",
      "to_date",
    ].forEach(
      (field) => {
        if (credentials[field] !== undefined && credentials[field] !== null && credentials[field] !== "") {
          params[field] = credentials[field];
        }
      }
    );

    return ApiService.query(ACCOUNTING_INVOICE_RESOURCE, params)
      .then(({ data }) => ({
        ...data,
        data: (data.data || []).map(mapAccountingInvoice),
      }))
      .catch((error) => Promise.reject(error.response?.data || error));
  },

  [EXPORT_ACCOUNTING_INVOICES](context, credentials = {}) {
    const params = { isExport: true };
    [
      "pnk_code",
      "invoice_code",
      "product_id",
      "product_name",
      "purchase_date",
      "created_date",
      "payment_status",
      "import_status",
      "from_date",
      "to_date",
    ].forEach(
      (field) => {
        if (credentials[field] !== undefined && credentials[field] !== null && credentials[field] !== "") {
          params[field] = credentials[field];
        }
      }
    );

    return ApiService.query(ACCOUNTING_INVOICE_RESOURCE, params)
      .then(({ data }) => data)
      .catch((error) => Promise.reject(error.response?.data || error));
  },

  [GET_ACCOUNTING_INVOICE](context, invoiceId) {
    return ApiService.get(ACCOUNTING_INVOICE_RESOURCE, invoiceId)
      .then(({ data }) => ({
        ...data,
        data: data.data ? mapAccountingInvoice(data.data) : null,
      }))
      .catch((error) => Promise.reject(error.response?.data || error));
  },

  [CREATE_ACCOUNTING_INVOICE](context, credentials) {
    return ApiService.post(
      ACCOUNTING_INVOICE_RESOURCE,
      buildAccountingInvoicePayload(credentials, false)
    )
      .then(({ data }) => data)
      .catch((error) => Promise.reject(error.response?.data || error));
  },

  [UPDATE_ACCOUNTING_INVOICE](context, credentials) {
    return ApiService.put(
      `${ACCOUNTING_INVOICE_RESOURCE}/${credentials.id}`,
      buildAccountingInvoicePayload(credentials, true)
    )
      .then(({ data }) => data)
      .catch((error) => Promise.reject(error.response?.data || error));
  },

  [DELETE_ACCOUNTING_INVOICE](context, invoiceId) {
    return ApiService.delete(ACCOUNTING_INVOICE_RESOURCE, invoiceId)
      .then(({ data }) => data)
      .catch((error) => Promise.reject(error.response?.data || error));
  },

  [GET_LOGISTICS_REQUESTS](context, credentials = {}) {
    const params = {
      page: credentials.page || 1,
    };

    if (credentials.type !== undefined && credentials.type !== null && credentials.type !== "") {
      params.type = credentials.type;
    }
    if (credentials.department_id) params.department_id = credentials.department_id;
    if (credentials.center_id) params.center_id = credentials.center_id;
    if (credentials.branch_id) params.branch_id = credentials.branch_id;
    if (credentials.person_in_charge_id !== undefined && credentials.person_in_charge_id !== null) {
      params.person_in_charge_id = credentials.person_in_charge_id;
    }
    if (Array.isArray(credentials.type_details) && credentials.type_details.length > 0) {
      params.type_details = credentials.type_details;
    }

    const statusCode = getStatusCode(credentials.status);
    if (statusCode !== null) {
      params.logistic_ticket_status = statusCode;
    }

    if (Array.isArray(credentials.date_range_created) && credentials.date_range_created.length === 2) {
      params["date_range[0]"] = credentials.date_range_created[0];
      params["date_range[1]"] = credentials.date_range_created[1];
    }

    return new Promise((resolve, reject) => {
      ApiService.query("logistic-tickets", params)
        .then(({ data }) => {
          resolve({
            ...data,
            data: (data.data || []).map(mapRequestItem),
          });
        })
        .catch((error) => {
          reject(error.response?.data || error);
        });
    });
  },
  [GET_DEPARTMENT_IN_CHARGE](context, payload) {
    return new Promise((resolve, reject) => {
        ApiService.query("logistic-tickets/list-person-in-charge", payload).then(({data}) => {
            resolve(data);
        }).catch(({response}) => {
            reject(response);
        });
    });
},

  [EXPORT_LOGISTICS_TICKETS](context, { type_details } = {}) {
    return new Promise((resolve, reject) => {
      ApiService.query("logistic-tickets/export", { type_details })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error.response?.data || error));
    });
  },

  [WORK_COORDINATION](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post("logistic-tickets/work-coordination", credentials)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error.response?.data || error));
    });
  },

  [CHANGE_LOGISTICS_STATUS_MULTIPLE](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post("logistic-tickets/change-status-multiple", {
        ticket_ids: credentials.ids,
        logistic_ticket_status: getStatusCode(credentials.status),
      })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error.response?.data || error));
    });
  },

  [DELETE_LOGISTICS_REQUEST](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post(`logistic-tickets/${credentials.id}/update-status`, {
        logistic_ticket_status: 5,
        note: credentials.reason || "",
      })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error.response?.data || error));
    });
  },

  [GET_LOGISTICS_REQUEST_DETAIL](context, requestId) {
    return new Promise((resolve, reject) => {
      ApiService.get("logistic-tickets", requestId)
        .then(({ data }) => {
          const rawData = data.data || {};
          resolve({
            ...data,
            data: mapRequestDetail(rawData),
            processingHistory: (rawData.logs || []).map(mapHistoryItem),
          });
        })
        .catch((error) => reject(error.response?.data || error));
    });
  },

  [SAVE_PROCESSING_RESULT](context, credentials) {
    const statusCode = getStatusCode(credentials.status);

    return new Promise((resolve, reject) => {
      ApiService.post(`logistic-tickets/${credentials.request_id}/update-status`, {
        logistic_ticket_status: statusCode,
        note: credentials.note || "",
      })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error.response?.data || error));
    });
  },

  [GET_DEPARTMENT_QUOTAS](context, credentials = {}) {
    const params = {};
    if (credentials.department_id) params.department_id = credentials.department_id;

    return new Promise((resolve, reject) => {
      ApiService.query("department-budget", params)
        .then(({ data }) => {
          let mapped = (data.data || []).map(mapQuotaItem);

          if (credentials.search) {
            const keyword = normalizeText(credentials.search).toLowerCase();
            mapped = mapped.filter((item) =>
              normalizeText(item.name).toLowerCase().includes(keyword)
            );
          }

          const paginated = buildPaginationFromArray(
            mapped,
            credentials.page || 1,
            credentials.limit || 20
          );

          resolve({
            error: data.error,
            message: data.message,
            data: paginated.data,
            pagination: paginated.pagination,
          });
        })
        .catch((error) => reject(error.response?.data || error));
    });
  },

  [UPDATE_DEPARTMENT_QUOTA](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post("department-budget", {
        department_id: credentials.department_id,
        total_budget: Number(credentials.quota) || 0,
      })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error.response?.data || error));
    });
  },

  [GET_PRODUCTS](context, credentials = {}) {
    const params = {
      page: credentials.page || 1,
    };

    if (credentials.search) params.search = credentials.search;
    if (credentials.status !== undefined && credentials.status !== null && credentials.status !== "") {
      params.status = credentials.status;
    }
    if (credentials.name) params.name = credentials.name;
    if (credentials.type !== undefined && credentials.type !== null && credentials.type !== "") {
      params.type = credentials.type;
    }
    if (
      credentials.type_detail !== undefined
      && credentials.type_detail !== null
      && credentials.type_detail !== ""
    ) {
      params.type_detail = credentials.type_detail;
    }
    if (
      credentials.reorder_level !== undefined
      && credentials.reorder_level !== null
      && credentials.reorder_level !== ""
    ) {
      params.reorder_level = credentials.reorder_level;
    }

    return new Promise((resolve, reject) => {
      ApiService.query("product", params)
        .then(({ data }) => {
          resolve({
            ...data,
            data: (data.data || []).map(mapProductItem),
          });
        })
        .catch((error) => reject(error.response?.data || error));
    });
  },

  [CREATE_PRODUCT](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post("product", {
        name: credentials.name,
        price: Number(credentials.price) || 0,
        type: Number(credentials.type),
        type_detail: Number(credentials.type_detail),
        description: credentials.description || "",
        logistic_product_status: Number(credentials.logistic_product_status) || 0,
        barcode: String(credentials.barcode ?? "").trim(),
        reorder_level: Number(credentials.reorder_level) || 0,
      })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error.response?.data || error));
    });
  },

  [UPDATE_PRODUCT](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.put(`product/${credentials.id}`, {
        name: credentials.name,
        price: Number(credentials.price) || 0,
        type: Number(credentials.type),
        type_detail: Number(credentials.type_detail),
        description: credentials.description || "",
        logistic_product_status: Number(credentials.logistic_product_status) || 0,
        barcode: String(credentials.barcode ?? "").trim(),
        reorder_level: Number(credentials.reorder_level) || 0,
      })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error.response?.data || error));
    });
  },

  [DELETE_PRODUCT](context, productId) {
    return new Promise((resolve, reject) => {
      ApiService.delete("product", productId)
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error.response?.data || error));
    });
  },

  [IMPORT_STOCK](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post(`product/quantity/${credentials.itemId}`, {
        quantity: Number(credentials.quantity) || 0,
        note: credentials.note || "",
      })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error.response?.data || error));
    });
  },

  [GET_LOGISTIC_BRANCHES]() {
    return new Promise((resolve, reject) => {
      ApiService.query("product/branches", {})
        .then(({ data }) => {
          resolve({
            ...data,
            data: (data.data || []).map((item) => ({
              id: item.id,
              name: item.name || "",
            })),
          });
        })
        .catch((error) => reject(error.response?.data || error));
    });
  },

  [EXPORT_STOCK](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post(`product/export-quantity/${credentials.itemId}`, {
        quantity: Number(credentials.quantity) || 0,
        note: credentials.note || "",
        branch_id: credentials.branch_id ?? null,
        branch_name: credentials.branch_name || "",
      })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error.response?.data || error));
    });
  },

  [GET_PRICE_HISTORY](context, productId) {
    return new Promise((resolve, reject) => {
      ApiService.get("product/price-history", productId)
        .then(({ data }) => {
          const history = (((data.data || {}).data) || []).map((item) => ({
            id: item.id,
            created_at: item.created_at,
            price: Number(item.price) || 0,
          }));

          resolve({
            error: data.error,
            message: data.message,
            data: history,
          });
        })
        .catch((error) => reject(error.response?.data || error));
    });
  },

  [EXPORT_STOCK_HISTORY](context, credentials = {}) {
    const params = {};
    ["name", "type", "type_detail", "reorder_level"].forEach((field) => {
      if (credentials[field] !== undefined && credentials[field] !== null && credentials[field] !== "") {
        params[field] = credentials[field];
      }
    });

    return ApiService.query("product/export-inventory-history", params)
      .then(({ data }) => data)
      .catch((error) => Promise.reject(error.response?.data || error));
  },

  [GET_PRODUCT_BARCODES](context, credentials = {}) {
    const params = {};
    ["name", "type", "type_detail", "reorder_level"].forEach((field) => {
      if (credentials[field] !== undefined && credentials[field] !== null && credentials[field] !== "") {
        params[field] = credentials[field];
      }
    });

    return ApiService.query("product/barcodes", params)
      .then(({ data }) => data)
      .catch((error) => Promise.reject(error.response?.data || error));
  },

  [GET_STOCK_HISTORY](context, productId) {
    return new Promise((resolve, reject) => {
      ApiService.get("product/inventory-history", productId)
        .then(({ data }) => {
          const history = (((data.data || {}).data) || []).map((item) => ({
            created_at: item.created_at,
            price: Number(item.price) || 0,
            stock_quantity: Number(item.stock_quantity) || 0,
            added_quantity: Number(item.added_quantity) || 0,
            note: item.note || "",
            type: Number(item.type) || 1,
            type_text: STOCK_LOG_TYPE_LABELS[Number(item.type) || 1] || "",
            branch_name: item.branch_name || "",
          }));

          resolve({
            error: data.error,
            message: data.message,
            data: history,
          });
        })
        .catch((error) => reject(error.response?.data || error));
    });
  },
  [GET_LIST_USER_GIFT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query("logistic-user-gift", payload)
          .then(({ data }) => {
            resolve({
              ...data,
              data: data.data
            });
          })
          .catch((error) => reject(error.response?.data || error));
    });
  },
  [EXPORT_USER_GIFT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query("logistic-user-gift/export", payload)
          .then(({ data }) => {
            resolve({
              ...data,
              data: data.data
            });
          })
          .catch((error) => reject(error.response?.data || error));
    });
  },
  [CHANGE_STATUS_SEND_GIFT](context, payload) {
    const requestId = typeof payload === "object" ? payload.id : payload;
    const body = typeof payload === "object" ? {
      status: payload.status,
      note: payload.note,
    } : {};

    return new Promise((resolve, reject) => {
      ApiService.post(`logistic-user-gift/change-status/${requestId}`, body)
          .then(({ data }) => {
            resolve(data);
          })
          .catch((error) => reject(error.response?.data || error));
    });
  },
};

const mutations = {};

Vue.prototype.$logisticStatusCode = getStatusCode;

export default {
  state,
  actions,
  mutations,
  getters,
};
